import type { TourConfig } from './types';

export const billingTour: TourConfig = {
  id: 'billing-page',
  name: 'Billing Tour',
  description: 'Learn about billing and payment history',
  requiredPath: '/dashboard/settings/billing',
  steps: [
    {
      element: '[data-tour="billing-content"]',
      popover: {
        title: 'Billing Overview',
        description:
          'View your subscription status, payment due notices, and manage billing details.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="billing-payment-history"]',
      popover: {
        title: 'Payment History',
        description:
          'View past payments, their status, and access payment links.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
